import './page.scss';
// Components
import '@/components/collection/collection-banner/collection-banner';
import '@/components/filters-mobile/components/filter-mobile/filter-mobile';
import '@/components/filters-mobile/filters-mobile';
import '@/components/filters/components/active-filter-value/active-filter-value';
import '@/components/filters/components/filter-value/filter-value';
import '@/components/filters/components/filter/filter';
import '@/components/filters/filters';
// Sections
import '@/sections/collection-main/collection-main';
import '@/sections/collection-navigation/collection-navigation';
